import { Action, combineReducers } from "@reduxjs/toolkit";

import { executors, executorsAction, StateExecutors } from "./executors";
import {
	replenishments,
	replenishmentsAction,
	StateReplenishments,
} from "./replenishments";

export type State = {
	executors: StateExecutors;
	replenishments: StateReplenishments;
};

export type Actions = {
	executors: typeof executorsAction;
	replenishments: typeof replenishmentsAction;
};

export const accountingReducer = combineReducers<State, Action<Actions>>({
	executors,
	replenishments,
});

export const accountingAction: Actions = {
	executors: executorsAction,
	replenishments: replenishmentsAction,
};

export default accountingReducer;
